<header class="filter-actions-container">
  <div class="material-table-search header-elements">
    <mat-form-field class="cbl-search-filter" appearance="fill">
      <input type="text" matInput [(ngModel)]="searchTerm" [disabled]="isLoading"
        placeholder="Filter" (input)="onSearchInput($event)" />
      <span matSuffix>
        <button type="button" class="filter-button"><mat-icon class="filter-icon">search</mat-icon></button>
      </span>
    </mat-form-field>
  </div>
  <div class="header-elements">
    <span class="dynamic-table-title">{{ sectionTitle }}</span>
  </div>
  <div class="header-elements action-elements">
    <app-download-button class="table-header-actions" [tableValues]="data" (buttonClicked)="exportData()"
      exportMessage="{{ exportConfig.exportMessage }}"></app-download-button>
  </div>
</header>
<div class="attendee-table-header">
  <span>Spin ID</span>
  <span>First Name</span>
  <span>Last Name</span>
  <span>Email</span>
  <span>Dealership</span>
  <span>Job Role</span>
</div>
@if (isLoading) {
<div class="accordion-skeleton">
  <app-loading-skeleton [count]="5" width="100%" height="56px" gap="8px" minHeight="320px" borderRadius="4px"></app-loading-skeleton>
</div>
} @else {
<mat-accordion multi class="survey-answer-accordion">
  @for (attendee of visibleAttendeeAnswers; track attendee.spinId + attendee.firstName + attendee.lastName + attendee.email) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="attendee-summary">
          <span>{{ attendee.spinId }}</span>
          <span>{{ attendee.firstName }}</span>
          <span>{{ attendee.lastName }}</span>
          <span>{{ attendee.email }}</span>
          <span>{{ attendee.dealership }}</span>
          <span>{{ attendee.jobRole }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="answer-header">
        <span>Question</span>
        <span>Answer</span>
      </div>
      @for (answer of attendee.answers; track answer.question) {
        <div class="answer-row">
          <span>{{ answer.question }}</span>
          <span>{{ answer.answer }}</span>
        </div>
      }
    </mat-expansion-panel>
  }
</mat-accordion>
<mat-paginator
  [length]="filteredAttendeeAnswers.length"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[10]"
  [showFirstLastButtons]="true"
  (page)="onPageChange($event)">
</mat-paginator>
}
